import { useEffect } from "react";
import api from "@/lib/api";

// Loads OneSignal Web SDK v16 from CDN and initializes it ONLY if the backend
// reports a configured app id. Graceful no-op when unconfigured (keys absent).
let initialized = false;

export function OneSignalInit() {
  useEffect(() => {
    if (initialized) return;
    let cancelled = false;
    (async () => {
      try {
        const { data } = await api.get("/public/settings");
        const appId = data.onesignal_app_id;
        if (cancelled || !appId) return;
        initialized = true;
        window.OneSignalDeferred = window.OneSignalDeferred || [];
        const s = document.createElement("script");
        s.src = "https://cdn.onesignal.com/sdks/web/v16/OneSignalSDK.page.js";
        s.defer = true;
        document.head.appendChild(s);
        window.OneSignalDeferred.push(async (OneSignal) => {
          try {
            await OneSignal.init({
              appId,
              allowLocalhostAsSecureOrigin: true,
              serviceWorkerPath: "onesignal/OneSignalSDKWorker.js",
              serviceWorkerParam: { scope: "/onesignal/" },
            });
          } catch (e) {
            /* e.g. non-whitelisted origin on preview — safe to ignore */
          }
        });
      } catch {
        /* no-op */
      }
    })();
    return () => { cancelled = true; };
  }, []);
  return null;
}

export function enablePush(tags) {
  window.OneSignalDeferred = window.OneSignalDeferred || [];
  window.OneSignalDeferred.push(async (OneSignal) => {
    try { await OneSignal.Notifications.requestPermission(); } catch (e) { /* no-op */ }
    try { await OneSignal.User.PushSubscription.optIn(); } catch (e) { /* no-op */ }
    if (tags) { try { await OneSignal.User.addTags(tags); } catch (e) { /* no-op */ } }
  });
}

export function enableOrderAlerts(orderNumber) {
  enablePush({ order_number: String(orderNumber) });
}
